import { render, staticRenderFns } from "./WrongOrdersForPopup.vue?vue&type=template&id=6e8f6102"
import script from "./WrongOrdersForPopup.vue?vue&type=script&lang=js"
export * from "./WrongOrdersForPopup.vue?vue&type=script&lang=js"
import style0 from "./WrongOrdersForPopup.vue?vue&type=style&index=0&id=6e8f6102&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports